const charlieUsersTableField = [
  {
    key: "username",
    sortable: true
  },
  {
    key: "quote_resume.queue",
    label: "queue",
    sortable: true
  },
  {
    key: "quote_resume.failed",
    label: "failed",
    sortable: true
  },
  {
    key: "quote_resume.process",
    label: "process",
    sortable: true
  },
  {
    key: "quote_resume.sent",
    label: "sent",
    sortable: true
  },
  {
    key: "is_busy",
    label: "Status",
    sortable: true
  },
  {
    key: "quotes",
    sortable: false
  },
  {
    key: "actions",
    sortable: false
  }
];

const uploaderUsersTableField = [
  {
    key: "username",
    sortable: true
  },
  {
    key: "name",
    sortable: true
  },
  {
    key: "surname",
    sortable: true
  },
  {
    key: "title",
    sortable: true
  },
  {
    key: "email",
    sortable: true
  },
  {
    key: "phone",
    sortable: true
  },
  {
    key: "actions",
    sortable: false
  }
];

module.exports = { charlieUsersTableField, uploaderUsersTableField };
